import { IbanElement } from '@stripe/react-stripe-js'
import { createCustomAndExternalAccount, createTokens, getAccountLink } from '../../apis/stripe'

export const handleSubmit = async (e, stripe, elements, component) => {
  e.preventDefault();
  component.setState({ isLoadingData: true });
  const { shop } = component.props;

  const { name, support = {} } = shop;
  const { validationMessage } = component.state;
  let isValidForm = true;
  validationMessage &&
    Object.keys(validationMessage).forEach(id => {
      if (validationMessage[id] === 'is-invalid' || !validationMessage[id]) {
        isValidForm = false;
        component.setState(prevState => {
          const { validationMessage } = prevState;
          return { validationMessage: { ...validationMessage, [id]: 'is-invalid' } };
        });
      }
    });
  const iban = elements.getElement(IbanElement);
  if (iban && isValidForm && iban._complete) {
    const { tokenIban, tokenAccount } = await createTokens(stripe, name, iban);
    if (tokenIban && tokenAccount) {
      const { bank_account: bankAccount = {}, id: token } = tokenIban;
      const { last4 } = bankAccount;
      const { id: accountId } = tokenAccount;
      const response = await createCustomAndExternalAccount(token, accountId, last4, support);
      if (response) {
        const link = await getAccountLink();
        if (link && typeof link === 'string') {
          window.location.replace(link);
        }
      }
    }
  } else {
    alert("Merci de remplir l'ensemble des champs !");
  }
  component.setState({ isLoadingData: false });
};